import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[cmInfiniteScroll]',
})
export class InfiniteScrollDirective {
  @Input() public elementHeight: number;
  @Input() public pageIndex: number;

  @Output() public scrollBeforeEnd: EventEmitter<void>;
  @Output() public scrollEnd: EventEmitter<void>;

  constructor() {
    this.scrollBeforeEnd = new EventEmitter<void>();
    this.scrollEnd = new EventEmitter<void>();
  }

  @HostListener('scroll', ['$event'])
  public onScroll($event: Event): void {
    const element = $event.target as HTMLElement;
    const elementHeight = (Number(this.elementHeight) || 0) * (Number(this.pageIndex) + 3);
    const scrollPosition = element.offsetHeight + element.scrollTop;

    if (this.elementHeight && this.pageIndex) {
      if (
        scrollPosition >= element.scrollHeight - elementHeight - 100 &&
        scrollPosition < element.scrollHeight - elementHeight
      ) {
        this.scrollBeforeEnd.emit();
      }
    }

    if (scrollPosition >= element.scrollHeight) {
      element.scrollTop = element.scrollTop - 1;
      this.scrollEnd.emit();
    }
  }
}
